import React from 'react';
export var IndeterminateIcon = () => /*#__PURE__*/React.createElement("svg", {
  width: "18",
  height: "2",
  viewBox: "0 0 18 2",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17 1H1",
  stroke: "#1F2D27",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));
//# sourceMappingURL=Indeterminate.js.map